
export const pollMetaNamePH = "John Smith";
// export const pollMetaHeadPH = "Poll purpose heading goes here";
export const pollMetaHeadPH = "Why create this poll?";
// eslint-disable-next-line
export const pollMetaDescrPH = "Lorem ipsum dolor sit amet, nibh duis alterum vix id, \
  his veri harum no. Eum argumentum intellegebat cu. Idque singulis assentior \
  at sit. No munere denique efficiendi cutm. Enim melius torquatos ne mei, sit \
  ad saepe consequuntur.";
export const pollMetaLocPH = "Planet Earth";
export const profPageLocPH = "Planet Earth";
export const profPageBioPH = 'The user has not entered a personal description, yet.';
// eslint-disable-next-line
// export const profPageBioPH = 'Tim Beggy was born in Pittsburgh, Pennsylvania. He is known \
//   for his work on Scouting Camp: Next Olympic Hopeful on NBC Sports (2017), House \
//   Hunters Family on HGTV (2017), Keep it potless on Nickelodeon (2017), Redneck \
//   Island on CMT (2012-2013), Brain Surge on Nickelodeon (2011), Shark Tank on ABC, \
//   Guts + Bolts on the History Channel, The Slant on Fox Sports, The Challenge and \
//   Road Rules on MTV.';



// WEBPACK FOOTER //
// ./src/views/placeholders.js